import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    cards: {
      purple: React.CSSProperties['color'];
      green: React.CSSProperties['color'];
      pink: React.CSSProperties['color'];
      orange: React.CSSProperties['color'];
      background: React.CSSProperties['color'];
    };
    tables: {
      empty: React.CSSProperties['color'];
      occupied: React.CSSProperties['color'];
      noActivity: React.CSSProperties['color'];
    };
    general: {
      white: React.CSSProperties['color'];
      black: React.CSSProperties['color'];
      gold: React.CSSProperties['color'];
      teel: React.CSSProperties['color'];
      cancel: React.CSSProperties['color'];
    };
  }

  interface ThemeOptions {
    cards: {
      purple: React.CSSProperties['color'];
      green: React.CSSProperties['color'];
      pink: React.CSSProperties['color'];
      orange: React.CSSProperties['color'];
      background: React.CSSProperties['color'];
    };
    tables: {
      empty: React.CSSProperties['color'];
      occupied: React.CSSProperties['color'];
      noActivity: React.CSSProperties['color'];
    };
    general: {
      white: React.CSSProperties['color'];
      black: React.CSSProperties['color'];
      gold: React.CSSProperties['color'];
      teel: React.CSSProperties['color'];
      cancel: React.CSSProperties['color'];
    };
  }
}

const theme = createTheme({
  cards: {
    purple: '#8676fe',
    green: '#1ab08c',
    pink: '#ff517b',
    orange: '#f16939',
    background: '#3d4244',
  },
  tables: {
    empty: '#EBEBF0',
    occupied: '#2086eb',
    noActivity: '#fa4a4a',
  },
  general: {
    white: '#fffff',
    black: '#000000',
    gold: '#eead70',
    teel: '#42beb9',
    cancel: '#C53B20',
  },
  palette: {
    primary: {
      main: '#0043b9',
    },
    secondary: {
      main: '#2086eb',
      light: '#42BED9',
      dark: '#051252',
    },
  },
  typography: {
    fontFamily: ['Fellix', 'Montserrat', 'Newsreader'].join(','),
    button: {
      fontFamily: 'Fellix',
      fontWeight: 600,
      fontSize: '1rem',
      textTransform: 'capitalize',
    },
    h5: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '15px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          height: '48px',
          width: '100%',
        },
      },
    },
  },
});

export default theme;
